import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronDown,
  faChevronRight,
  faTimes,
  faPlus,
  faHeart as fasHeart,
  faBookmark as fasBookmark,
  faSlidersH,
  faEllipsisV,
  faExclamationCircle,
  faImage,
  faCamera,
  faUsers,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import {
  faBookmark,
  faHeart,
  faComment,
  faComments,
  faPaperPlane,
  faEnvelope,
  faHourglass,
} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook,
  faTwitter,
  faInstagram,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';


library.add(
  faChevronDown,
  faChevronRight,
  faTimes,
  faPlus,
  fasHeart,
  fasBookmark,
  faSlidersH,
  faEllipsisV,
  faExclamationCircle,
  faImage,
  faCamera,
  faUsers,
  faTrash,
);
library.add(
  faBookmark,
  faHeart,
  faComment,
  faComments,
  faPaperPlane,
  faEnvelope,
  faHourglass,
);
library.add(
  faFacebook,
  faTwitter,
  faInstagram,
  faYoutube,
);
